import BedIcon from "@assets/icons/rest.svg";
import ClockIcon from "@assets/icons/clock.svg";
import ListIcon from "@assets/icons/list.svg";
import { useI18n } from "@core/i18n/i18n";
import { isDurationExercise, REPETITION_TIME_IN_SEC } from "@domain/exercise/exercise";
import { Session } from "@domain/program/session";
import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import { row } from "@ui/style/layout";
import { classNames } from "primereact/utils";
import React from "react";

interface DayColumnProps {
	session: Session;
	className?: string;
}

export const DayColumnHeader: React.FC<DayColumnProps> = ({ session, className }) => {
	const { format, formatDuration } = useI18n();

	const sessionTimeInSec = session.exercises.reduce(
		(total, exercise) =>
			total +
			exercise.setCount * (isDurationExercise(exercise) ? exercise.units : exercise.units * REPETITION_TIME_IN_SEC),
		0,
	);

	return (
		<ColumnHeader className={classNames("p-size-s-bold", className)}>
			{session.exercises.length === 0 ? (
				<ColumnHeaderDetails>
					<BedIcon width="16" height="16" />
					<span>{format("programBuilder.dayTable.emptyColumn")}</span>
				</ColumnHeaderDetails>
			) : (
				<>
					<ColumnHeaderDetails>
						<ListIcon width="16" height="16" />
						<span>{session.exercises.length}</span>
					</ColumnHeaderDetails>
					<ColumnHeaderDetails>
						<ClockIcon width="16" height="16" style={{ marginBottom: 2 }} />
						<span>
							<span>{formatDuration(sessionTimeInSec)}</span>
						</span>
					</ColumnHeaderDetails>
				</>
			)}
		</ColumnHeader>
	);
};

const ColumnHeader = styled.div`
	${row(10, "center", "center")}
	border-radius: 8px;
	padding: 8px;
	line-height: 1.375rem;
	color: ${colors.grey};
`;

const ColumnHeaderDetails = styled.div`
	${row(4, "center", "center")};
`;
